<template lang="pug">
  .settings(v-if='settings')
    template
      span
        | {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}:
        | {{ settings.themes ? themeNames : ''}}
      br
      span
        | {{ $i18n.t('trainer.trainer_gameFormSetting_isChooseByAlphabetSettingEnabled') }}:
        | {{  settings.isChosenLettersSettingEnabled ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf')  }}
      br
      span(v-if="settings.isChosenLettersSettingEnabled")
        | {{ $i18n.t('trainer.trainer_gameFormSetting_chooseByAlphabet') }}:
        | {{ settings.chosenLetters ? letters : ''  }}
      br
      span
        | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') }}:
        | {{ settings.amountOfPairs }}
      br
      span
        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
        | {{ settings.numOfExamples }}
      br
      span
        | {{ $i18n.t('trainer.trainer_gamePlayBox_tip') }}:
        | {{ settings.isHintEnabled ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
      br
    br
    slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
        computed: {
            themeNames() {
                return this.settings.themes
                    .map(theme => this.$i18n.t('trainer.trainer_gameFormSetting_' + `${theme.value}`))
                    .join('; ');
            },
            letters() {
                return this.settings.chosenLetters.map(theme => theme).join('; ');
            },
        },
    };
</script>
